import { bearerFetcher, useAuthFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV2 } from "@/endpoints/m2m-cleaning.cleaner-v2"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"
import { uploadBlobWithPresignedPut } from "@/utils/presignedUpload"

export interface Trouble {
    id: string
    cleaningId?: string
    listingId: string
    companyId: string
    createdAt: number
    description: string
    isResolved: boolean
    pictures: string[]
    resolvedAt: number
}

export const useTroublesByListingId = (token: string, listingId?: string) => {
    return useAuthFetch<{ data: Trouble[] }>(
        token,
        listingId
            ? m2mCleaning_cleanerV2.listTroublesByListingId({ listingId })
            : null,
        {
            authTokenHeader: "Authorization"
        }
    )
}

export const callRequestCreateOperationTroubleWithUploadedPictures = async (
    token: string,
    operationId: string,
    input: { description: string; blobs: Blob[] }
): Promise<{ data?: { id: string }; error?: Error }> => {
    try {
        const uploadIds = await Promise.all(
            input.blobs.map(async blob => {
                const issueUrl =
                    m2mCleaning_cleanerV3.issueOperationTroublePictureUploadUrl(
                        { operationId }
                    )
                const { uploadId } = await uploadBlobWithPresignedPut({
                    token,
                    issueUrl,
                    blob
                })
                return uploadId
            })
        )

        const result = await bearerFetcher<{ id: string }>(
            token,
            m2mCleaning_cleanerV3.createOperationTroubleWithUploadedPictures({
                operationId
            }),
            {
                method: "POST",
                body: JSON.stringify({
                    description: input.description,
                    uploadIds
                })
            }
        )
        if (result.error) {
            return { data: undefined, error: new Error(result.error.message) }
        }
        if (!result.data?.id) {
            return {
                data: undefined,
                error: new Error("id missing in complete response")
            }
        }
        return { data: result.data, error: undefined }
    } catch (error) {
        console.error(
            "[callRequestCreateOperationTroubleWithUploadedPictures] API呼び出しエラー",
            {
                operationId,
                error,
                errorMessage:
                    error instanceof Error ? error.message : String(error),
                errorStack: error instanceof Error ? error.stack : undefined
            }
        )
        return {
            data: undefined,
            error:
                error instanceof Error
                    ? error
                    : new Error(
                          `トラブル報告のAPI呼び出しに失敗しました: ${String(error)}`
                      )
        }
    }
}
